/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type StationaryUnitZoneViolationEvent,
    StationaryUnitZoneViolationEventFromJSON,
    StationaryUnitZoneViolationEventToJSON,
} from '../models/StationaryUnitZoneViolationEvent';
import {
    type StationaryUnitZoneViolationEventCreate,
    StationaryUnitZoneViolationEventCreateFromJSON,
    StationaryUnitZoneViolationEventCreateToJSON,
} from '../models/StationaryUnitZoneViolationEventCreate';
import {
    type StationaryUnitZoneViolationIncident,
    StationaryUnitZoneViolationIncidentFromJSON,
    StationaryUnitZoneViolationIncidentToJSON,
} from '../models/StationaryUnitZoneViolationIncident';

export interface EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest {
    stationaryUnitZoneViolationEventCreate: StationaryUnitZoneViolationEventCreate;
}

export interface EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest {
    id: string;
}

export interface EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest {
    id: string;
}

/**
 * EloshieldEventsApi - interface
 * 
 * @export
 * @interface EloshieldEventsApiInterface
 */
export interface EloshieldEventsApiInterface {
    /**
     * Creates request options for eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEvent without sending the request
     * @param {StationaryUnitZoneViolationEventCreate} stationaryUnitZoneViolationEventCreate 
     * @throws {RequiredError}
     * @memberof EloshieldEventsApiInterface
     */
    eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequestOpts(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new stationary unit zone violation event.
     * @summary Create a stationary unit zone violation event
     * @param {StationaryUnitZoneViolationEventCreate} stationaryUnitZoneViolationEventCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldEventsApiInterface
     */
    eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRaw(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnitZoneViolationEvent>>;

    /**
     * Create a new stationary unit zone violation event.
     * Create a stationary unit zone violation event
     */
    eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEvent(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnitZoneViolationEvent>;

    /**
     * Creates request options for eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEvent without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof EloshieldEventsApiInterface
     */
    eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequestOpts(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Retrieve a single stationary unit zone violation event by ID.
     * @summary Read a stationary unit zone violation event
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldEventsApiInterface
     */
    eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRaw(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnitZoneViolationEvent>>;

    /**
     * Retrieve a single stationary unit zone violation event by ID.
     * Read a stationary unit zone violation event
     */
    eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEvent(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnitZoneViolationEvent>;

    /**
     * Creates request options for eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncident without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof EloshieldEventsApiInterface
     */
    eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequestOpts(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest): Promise<runtime.RequestOpts>;

    /**
     * Retrieve a single stationary unit zone violation incident by ID.
     * @summary Read a stationary unit zone violation incident
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldEventsApiInterface
     */
    eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRaw(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnitZoneViolationIncident>>;

    /**
     * Retrieve a single stationary unit zone violation incident by ID.
     * Read a stationary unit zone violation incident
     */
    eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncident(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnitZoneViolationIncident>;

}

/**
 * 
 */
export class EloshieldEventsApi extends runtime.BaseAPI implements EloshieldEventsApiInterface {

    /**
     * Creates request options for eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEvent without sending the request
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequestOpts(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitZoneViolationEventCreate'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitZoneViolationEventCreate',
                'Required parameter "stationaryUnitZoneViolationEventCreate" was null or undefined when calling eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_events/stationary_unit_zone_violation_events/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationaryUnitZoneViolationEventCreateToJSON(requestParameters['stationaryUnitZoneViolationEventCreate']),
        };
    }

    /**
     * Create a new stationary unit zone violation event.
     * Create a stationary unit zone violation event
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRaw(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnitZoneViolationEvent>> {
        const requestOptions = await this.eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitZoneViolationEventFromJSON(jsonValue));
    }

    /**
     * Create a new stationary unit zone violation event.
     * Create a stationary unit zone violation event
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEvent(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnitZoneViolationEvent> {
        const response = await this.eloshieldEventsStationaryUnitZoneViolationEventsCreateStationaryUnitZoneViolationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEvent without sending the request
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequestOpts(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_events/stationary_unit_zone_violation_events/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a single stationary unit zone violation event by ID.
     * Read a stationary unit zone violation event
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRaw(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnitZoneViolationEvent>> {
        const requestOptions = await this.eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitZoneViolationEventFromJSON(jsonValue));
    }

    /**
     * Retrieve a single stationary unit zone violation event by ID.
     * Read a stationary unit zone violation event
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEvent(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnitZoneViolationEvent> {
        const response = await this.eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncident without sending the request
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequestOpts(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncident().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_events/stationary_unit_zone_violation_events/incident/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a single stationary unit zone violation incident by ID.
     * Read a stationary unit zone violation incident
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRaw(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnitZoneViolationIncident>> {
        const requestOptions = await this.eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitZoneViolationIncidentFromJSON(jsonValue));
    }

    /**
     * Retrieve a single stationary unit zone violation incident by ID.
     * Read a stationary unit zone violation incident
     */
    async eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncident(requestParameters: EloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnitZoneViolationIncident> {
        const response = await this.eloshieldEventsStationaryUnitZoneViolationEventsReadStationaryUnitZoneViolationIncidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
